import { DocumentStatus } from "../../../base/documents/document-statuses/document-status.model";

export class SaleDocumentStatus extends DocumentStatus { }
